import { render } from "./ViewOrderDevices.vue?vue&type=template&id=11c752f4&ts=true"
import script from "./ViewOrderDevices.vue?vue&type=script&lang=ts"
export * from "./ViewOrderDevices.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__